module.exports = __webpack_public_path__ + "img/posts.6a7abd2e.svg";